import Component from 'component';
import { getLineHeight } from '../helpers/getLineHeight';

class ReadMore extends Component {
  constructor(el, config) {
    super(el, config);

    this.dom.$text.wrapInner('<div class="read-more__inner"></div>');
    this.dom.$textInner = this.dom.$text.find('.read-more__inner');
    this.dom.$textInner.css('overflow', 'hidden');

    this.configureComponent();
  }

  setupDefaults() {
    this.activeBreakpoint;
    this.isInitialized = false;
    this.isExpanded = false;
    this.appliedConfig = this.config;
    this.margins = 0;

    this.dom = {
      $window: $(window),
      $text: this.$el.find(this.config.textSelector)
    };
  }

  addListeners() {
    this.dom.$window.on('resize', ::this.configureComponent);
    this.$el.on(
      'click',
      `.${this.config.buttonClass || 'btn-read-more'}`,
      ::this.toggleTextHeight
    );
  }

  configureComponent() {
    this.appliedConfig = this.config;
    this.textHeight = this.dom.$textInner.height();
    this.lineHeight = getLineHeight(this.dom.$textInner);

    // Check if current mq has custom config
    if (this.config.responsive && this.config.responsive.length) {
      this.config.responsive.forEach(responsive => {
        if (
          window.matchMedia(`(max-width: ${responsive.breakpoint}px)`).matches
        ) {
          this.appliedConfig = { ...this.config, ...responsive.config };
        }
      });
    }

    let totalLines = 0;
    // Get child block elements
    const childElements = this.dom.$textInner.children().filter((i, el) => {
      return $(el).css('display') === 'block';
    });

    // Check if element has child elements
    if (childElements.length) {
      this.margins = 0;
      childElements.each((i, el) => {
        // Get number of lines for each p tag
        const textHeight = $(el).height();
        const textLines = textHeight / this.lineHeight;

        totalLines += textLines;

        if (
          this.appliedConfig.maxLines &&
          totalLines < this.appliedConfig.maxLines
        ) {
          this.margins +=
            parseInt($(el).css('margin-top')) +
            parseInt($(el).css('margin-bottom'));
        } else if (
          this.appliedConfig.maxLines &&
          totalLines === this.appliedConfig.maxLines
        ) {
          this.margins += parseInt($(el).css('margin-top'));
        }
      });
    } else {
      totalLines = this.textHeight / this.lineHeight;
    }

    const shouldInitialize =
      this.appliedConfig.maxLines && totalLines > this.appliedConfig.maxLines;

    if (this.isInitialized !== shouldInitialize) {
      this.isInitialized = shouldInitialize;
      if (shouldInitialize) {
        this.$el.addClass('read-more__initialized');
        $('<button class="btn-read-more"></button>').insertAfter(
          this.dom.$text
        );
        this.dom.$link = this.$el.find('.btn-read-more');
        this.toggleTextHeight();
      } else {
        this.$el.removeClass('read-more__initialized');
        this.dom.$text.css('height', '');
        this.$el.find('.btn-read-more').remove();
      }
    }
  }

  toggleTextHeight(event) {
    if (event) {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
    }

    if (this.isExpanded) {
      this.$el.addClass('read-more__expanded');
      this.dom.$text.height(this.textHeight);
      this.dom.$link.html(
        `<svg><use xlink:href="#minus" /></svg>${
          this.$el.data('readLessLabel') || ''
        }`
      );
    } else {
      this.$el.removeClass('read-more__expanded');
      this.dom.$text.height(
        this.appliedConfig.maxLines * this.lineHeight + this.margins
      );
      this.dom.$link.html(
        `<svg><use xlink:href="#plus" /></svg>${
          this.$el.data('readMoreLabel') || ''
        }`
      );
    }
  }
}

export default ReadMore;



// WEBPACK FOOTER //
// ./src/btu/js/components/ReadMore.js